// Componente Cumulo.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Cúmulo por producto</strong>
          </div>
          <div>
            <b-row>
              <b-col lg="6"> </b-col>
              <b-col lg="6">
                <b-form-group label label-for="filtroProceso">
                  <b-form-input
                    id="filtroProceso"
                    type="text"
                    placeholder="Filtrar"
                    v-model="filters[0].value"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <div ref="refTable">
                  <data-tables
                    ref="refTableData"
                    :data="datacumulo"
                    name="table"
                    class="table-responsive"
                    :current-page.sync="pagina"
                    :table-props="tableProps"
                    :filters="filters"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    layout="table"
                    >
                    <el-table-column
                      v-for="title in titles"
                      :min-width="title.minwidth"
                      :prop="title.prop"
                      :label="title.label"
                      :key="title.label"
                      :align="title.align"
                      :formatter="formatter"
                      sortable="custom"
                      name="table"
                      class="table-responsive"
                      >
                    </el-table-column>

                    <el-table-column  label="" min-width="100px" align="center">
                      <template slot-scope="scope">
                        <b-button size="sm" variant="primary" @click="recuperar_detcumulo(scope.row.producto)" ><i class="fa fa-search"></i> Detalle</b-button>
                      </template>
                    </el-table-column>

                  </data-tables>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>Líneas vigentes </strong>
          </div>
          <div>
            <b-row>
              <b-col lg="12">
                <div ref="refTable">
                  <data-tables
                    ref="refTableData"
                    :data="datalinvig"
                    name="table"
                    class="table-responsive"
                    :current-page.sync="pagina"
                    :table-props="tableProps"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    layout="table"
                    >
                    <el-table-column
                      v-for="title in titleslin"
                      :min-width="title.minwidth"
                      :prop="title.prop"
                      :label="title.label"
                      :key="title.label"
                      :align="title.align"
                      :formatter="formatter"
                      sortable="custom"
                      name="table"
                      class="table-responsive"
                      >
                    </el-table-column>

                    <el-table-column  label="" min-width="100px" align="center">
                      <template slot-scope="scope">
                        <b-button size="sm" variant="primary" @click="recuperar_detlinea(scope.row.nrosolici)" ><i class="fa fa-search"></i> Detalle</b-button>
                      </template>
                    </el-table-column>

                  </data-tables>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>

        <!-- <b-card>
          <div slot="header">
            <strong>Líneas históricas </strong>
          </div>
          <div>
            <b-row>
              <b-col lg="12">
                <div ref="refTable">
                  <data-tables
                    ref="refTableData"
                    :data="datalinhis"
                    name="table"
                    class="table-responsive"
                    :current-page.sync="pagina"
                    :table-props="tableProps"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    layout="table"
                    >
                    <el-table-column
                      v-for="title in titleslin"
                      :min-width="title.minwidth"
                      :prop="title.prop"
                      :label="title.label"
                      :key="title.label"
                      :align="title.align"
                      :formatter="formatter"
                      sortable="custom"
                      name="table"
                      class="table-responsive"
                      >
                    </el-table-column>

                    <el-table-column  label="" min-width="100px" align="center">
                      <template slot-scope="scope">
                        <b-button size="sm" variant="primary" @click="recuperar_detlinea(scope.row.nrosolici, scope.row.garcre)" ><i class="fa fa-search"></i> Detalle</b-button>
                      </template>
                    </el-table-column>
                  </data-tables>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card> -->

      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle"
      cancel-title="Cancelar"
      v-model="modaldetcumulo"
      @cancel="modaldetcumulo = false"
    >
    <b-row class="my-1">
      <b-col sm="6"></b-col>
      <b-col sm="6">
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroNombre"
            type="text"
            placeholder="Buscar"
            v-model="filters[0].value"
            size="sm"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="datadetcumulo"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titlesdetcumulo"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
            </el-table-column>
            <el-table-column  label="" min-width="100px" align="center">
                    <template slot-scope="scope">
                      <b-button size="sm" variant="primary" @click="recuperar_detpoliza(scope.row.poliza, scope.row.item, scope.row.endoso)" >Detalle</b-button>
                    </template>
                  </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      :title= "titlemodallindet"
      cancel-title="Cancelar"
      v-model="modallindetvig"
      @cancel="modallindetvig = false"
    >
    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="datalindetvig"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titleslindetvig"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Póliza"
      cancel-title="Cancelar"
      v-model="modaldetpoliza"
      @cancel="modaldetpoliza = false"
    >
        <center><h5>COPIA NO VALIDA</h5></center>
        <p><b>Riesgo: </b> {{ this.datosFormulario.producto }} </p>
        <p><b>Póliza: </b> {{ this.datosFormulario.poliza }} <b>Propuesta:</b> {{ this.datosFormulario.propuesta }} <b>Sucursal:</b> {{ this.datosFormulario.sucursal }} </p>
        <p><b>Moneda: </b> {{ this.datosFormulario.moneda }} </p>
        <p><b>Corredor: </b> {{ this.datosFormulario.corredor }} <b>Rut: </b> {{ this.datosFormulario.rutnumcorred }}-{{ this.datosFormulario.rutdvcorred}} <b>Código: </b> {{ this.datosFormulario.codigocorred}}</p>
        <p><b>Contratante: </b> {{ this.datosFormulario.contratante }} <b>Rut: </b> {{ this.datosFormulario.rutnumcon }}-{{ this.datosFormulario.rutdvcon}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direccon }} </p>
        <p><b>Item: </b> {{ this.datosFormulario.item }} <b>Endoso: </b> {{ this.datosFormulario.endoso }}</p>
        <p><b>Asegurado: </b> {{ this.datosFormulario.asegurado }} <b>Rut: </b>{{ this.datosFormulario.rutnumaseg}}-{{ this.datosFormulario.rutdvaseg}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direcaseg }} </p>
        <p><b>Vig. Desde: </b> {{ this.datosFormulario.vigdesde }} <b>Vig. Hasta: </b> {{ this.datosFormulario.vighasta }}</p>
        <p><b>Acción: </b> {{ this.datosFormulario.accion }} </p>
        <br>
        <table class="table">
          <tr>
          <td align ="center"><b>Monto asegurado</b></td>		<td align ="center"><b>Prima neta</b></td>	<td align ="center"><b>IVA</b></td>
          </tr>
          <tr>
          <td align ="center">{{this.datosFormulario.montoaseg}}</td>		<td align ="center">{{this.datosFormulario.primaneta}}</td>	<td align ="center">{{this.datosFormulario.iva}}</td>
          </tr>
        </table>
        
        <br>
        <p><b>Detalle de Materia Asegurada</b></p>
        <p>{{this.datosFormulario.materia}}</p>
        <br>
        <p><b>Póliza</b> {{ this.datosFormulario.poliza }} <b>Endoso</b> {{ this.datosFormulario.endoso }} <b>Item</b> {{ this.datosFormulario.item }}  </p>
        <p><b>Firma Autorizada</b> </p>
        
        <!-- <center><p><b>Observaciones</b></p></center>
        {{this.datosFormulario.observaciones}} -->

      
      <b-row>
    
      </b-row>
    </b-modal>


    

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Cumulo",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    cod_asegurado: Number,
    participacion: Number,
    
  },

  data: function() {
    return {
      datacumulo:[],
      datadetcumulo:[],
      datalinvig:[],
      datalindetvig:[],
      datalinhis:[],
      datalindethis:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetcumulo: false,
      modallindetvig: false,
      modaldetpoliza: false,
      titlemodallindet:"",
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },
      
      titles: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "primaneta",
          label: "Prima Neta",
          align: "right",
          minwidth:'150'
        },      
        {
          prop: "mtoaseg",
          label: "Monto Asegurado",
          align: "right",
          minwidth:'150'
        }
        
      ],

      titleslin: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "vigdesde",
          label: "Vigencia desde",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "vighasta",
          label: "Vigencia hasta",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "mtoapr",
          label: "Monto aprobado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "feapr",
          label: "Fecha aprobación",
          align: "center",
          minwidth:'100'
        }

        
      ],
      
      titleslindetvig:[],

      titleslindetvigcre: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "asegurado",
          label: "Asegurado",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "mtosol",
          label: "Monto Solicitado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "mtoapr",
          label: "Monto Aprobado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "analista",
          label: "Analista",
          align: "center",
          minwidth:'70'
        },
        {
          prop: "tipo",
          label: "Tipo Solicitud",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "vigdesde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "vighasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "plazo",
          label: "Plazo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "pagador",
          label: "Pagador",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "documento",
          label: "Documento",
          align: "center",
          minwidth:'150'
        },
        {
          prop: "ansobsexterna",
          label: "Comentario al Resultado",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "motivocancelacion",
          label: "Mot.Cancelación",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "observaciones",
          label: "Comentario Interno",
          align: "left",
          minwidth:'200'
        },
        
      ],

      titleslindetviggar: [
        {
          prop: "linanalisis",
          label: "Análisis",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "asegurado",
          label: "Afianzado",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "mtosol",
          label: "Monto Solicitado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "mtoapr",
          label: "Monto Aprobado",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "vigdesde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "vighasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "contragarantia",
          label: "ContraGarantía",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "observaciones",
          label: "Comentario del Análisis",
          align: "left",
          minwidth:'200'
        }
        
      ],

      titlesdetcumulo: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "item",
          label: "Item",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "endoso",
          label: "Endoso",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "mtoneto",
          label: "Monto Neto",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "mtoaseg",
          label: "Monto Asegurado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "vigdesde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "vighasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "emision",
          label: "Fecha de Emisión",
          align: "center",
          minwidth:'100'
        }
      ],
      
      datosFormulario: {
        producto: "",
        poliza: "",
        endoso: "",
        item: "",
        propuesta: "",
        accion: "",
        moneda: "",
        vigdesde: "",
        vighasta: "",
        montoaseg: "",
        primaneta: "",
        iva: "",
        materia: "",
        sucursal: "",
        corredor: "",
        rutnumcorred: "",
        rutdvcorred: "",
        codigocorred: "",
        asegurado: "",
        direcaseg: "",
        ciudadaseg: "",
        rutnumaseg: "",
        rutdvaseg: "",
        contratante: "",
        rutnumcon: "",
        rutdvcon: "",
        direccon: "",
        ciudadcon: "",
        observaciones: "",
      },

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {
    
    customButtonsForRow(row) {
      var botones = new Array();
          
      var obj = new Object();
        obj.tooltip = "Detalle";
        obj.id = 1;
        obj.name=" Detalle";
        obj.icon = "fa fa-search";
        obj.type = "success";
        obj.handler= _ => {
          this.$session.start();
          this.recuperar_detcumulo(row.producto);
          }
          botones.push(obj);
          
        return botones;
    },        

    formatter(row, column) {
      if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_cumulo() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_cumulo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado,
          this.participacion
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datacumulo = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detcumulo(p_producto) {
         
      this.$Progress.start(); 
      return apiConsultaCliente
          .recuperar_detcumulo(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.cod_asegurado,
            p_producto

            )  
            .then(response => {
              this.modaldetcumulo = true;            
              response.data = this.keysMinuscula(response.data);
              this.datadetcumulo = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

    recuperar_lineasvig() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_lineasvig(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datalinvig = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detlinea(p_nrosolici, p_garcre) {
      console.log(p_garcre);
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_detlinea(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_nrosolici
          )  
          .then(response => {
            
            if(p_garcre == "GAR"){
              this.titlemodallindet = "Análisis Garantía";
              this.titleslindetvig = this.titleslindetviggar;

            } else{
              this.titlemodallindet = "Análisis Crédito";
              this.titleslindetvig = this.titleslindetvigcre;
            }

            this.modallindetvig= true;
            response.data = this.keysMinuscula(response.data);
            this.datalindetvig = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },


    recuperar_lineashist() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_lineashist(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datalinhis = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detpoliza(p_poliza, p_item, p_endoso) {
          console.log(p_poliza, p_endoso);
            this.$Progress.start(); 
           
            return apiConsultaCliente
              .recuperar_detpoliza(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                p_poliza,
                p_item,
                p_endoso
              )  
              .then(response => {
                this.modaldetpoliza = true;
                
                response.data = this.keysMinuscula(response.data);
                var datadetpoliza = response.data.res;
                console.log(datadetpoliza);
                for (var i = 0; i < datadetpoliza.length; i++) {

                  this.datosFormulario.producto = datadetpoliza[i]["producto"];
                  this.datosFormulario.poliza = datadetpoliza[i]["poliza"];
                  this.datosFormulario.endoso = datadetpoliza[i]["endoso"];
                  this.datosFormulario.item = datadetpoliza[i]["item"];
                  this.datosFormulario.propuesta = datadetpoliza[i]["propuesta"];
                  this.datosFormulario.accion = datadetpoliza[i]["accion"];
                  this.datosFormulario.moneda = datadetpoliza[i]["moneda"];
                  this.datosFormulario.vigdesde = datadetpoliza[i]["vigdesde"];
                  this.datosFormulario.vighasta = datadetpoliza[i]["vighasta"];
                  this.datosFormulario.montoaseg = datadetpoliza[i]["montoaseg"];
                  this.datosFormulario.primaneta = datadetpoliza[i]["primaneta"];
                  this.datosFormulario.iva = datadetpoliza[i]["iva"];
                  this.datosFormulario.materia = datadetpoliza[i]["materia"];
                  this.datosFormulario.sucursal = datadetpoliza[i]["sucursal"];
                  this.datosFormulario.corredor = datadetpoliza[i]["corredor"];
                  this.datosFormulario.rutnumcorred = datadetpoliza[i]["rutnumcorred"];
                  this.datosFormulario.rutdvcorred = datadetpoliza[i]["rutdvcorred"];
                  this.datosFormulario.codigocorred = datadetpoliza[i]["codigocorred"];
                  this.datosFormulario.asegurado = datadetpoliza[i]["asegurado"];
                  this.datosFormulario.direcaseg = datadetpoliza[i]["direcaseg"];
                  this.datosFormulario.ciudadaseg = datadetpoliza[i]["ciudadaseg"];
                  this.datosFormulario.rutnumaseg = datadetpoliza[i]["rutnumaseg"];
                  this.datosFormulario.rutdvaseg = datadetpoliza[i]["rutdvaseg"];
                  this.datosFormulario.contratante = datadetpoliza[i]["contratante"];
                  this.datosFormulario.rutnumcon = datadetpoliza[i]["rutnumcon"];
                  this.datosFormulario.rutdvcon = datadetpoliza[i]["rutdvcon"];
                  this.datosFormulario.direccon = datadetpoliza[i]["direccon"];
                  this.datosFormulario.ciudadcon = datadetpoliza[i]["ciudadcon"];
                  this.datosFormulario.observaciones = datadetpoliza[i]["observacion"];

                }
                
                this.$Progress.finish();
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
        },




  },


  
  
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_cumulo();
    this.recuperar_lineasvig();
    // this.recuperar_lineashist();

  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>